// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"457c6db1","201":"a167e41a","384":"1e0f90ec","415":"2a892de8","500":"3422b616","550":"6e78d498","622":"8c850dc4","644":"12ca5c01","686":"3eba5b2c","719":"0a89b44f","768":"6df106d2"}[chunkId] + ".chunk.js";
};